import React from 'react';
import { TableCell, TableSortLabel, Box } from '@mui/material';

/**
 * A MUI TableCell header that acts as a sort control when `field` is
 * provided. Pass the current sort `field`/`direction` (from useTableSort)
 * and `onSort(field)` (typically the hook's `toggle`).
 *
 * When `field` is omitted the cell renders as a plain, non-sortable header.
 */
export default function SortableHeaderCell({ field, label, sortField, direction, onSort, align }) {
  if (!field) {
    return <TableCell align={align}>{label}</TableCell>;
  }

  const active = sortField === field;

  return (
    <TableCell align={align} sortDirection={active ? direction : false}>
      <TableSortLabel
        active={active}
        direction={active ? direction : 'asc'}
        hideSortIcon={!active}
        onClick={() => onSort(field)}
      >
        {label}
        {active ? (
          <Box component="span" sx={visuallyHidden}>
            {direction === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </Box>
        ) : null}
      </TableSortLabel>
    </TableCell>
  );
}

// Same recipe MUI's own visuallyHidden helper uses - kept inline to avoid
// pulling in the @mui/utils dependency just for this.
const visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px',
};
